export default "__VITE_ASSET__ClfOtmjN__"